import { queryOptions, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { fetchAll, fetchById, updateStatus } from '.';
import type { UserStatus } from './types';

export const getUsersOptions = (projectId: string, query: Record<string, string | number>) =>
  queryOptions({
    queryKey: ['projects', 'users', projectId, query],
    queryFn: () => fetchAll(projectId, query),
  });

export const useGetUserById = (projectId: string, userId: string) => {
  return useQuery({
    queryKey: ['users', 'details', userId],
    queryFn: () => fetchById(projectId, userId),
  });
};

export const useUpdateUserStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      projectId,
      userId,
      status,
    }: {
      projectId: string;
      userId: string;
      status: UserStatus;
    }) => updateStatus(projectId, userId, status),
    onSuccess: (_, { projectId, userId }) => {
      queryClient.invalidateQueries({ queryKey: ['projects', 'users', projectId] });
      queryClient.invalidateQueries({ queryKey: ['users', 'details', userId] });
    },
  });
};
